import React from 'react';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import QualityAlertAddEdit from './quality-alert-add-edit';

const { QUALITYALERT_ADD_EDIT } = MODAL_TYPES;

const QualityAlertModals = () => {
  return (
    <>
      <QualityAlertAddEdit modalId={QUALITYALERT_ADD_EDIT} />
    </>
  );
};

export default QualityAlertModals;
